<template>
  <v-hover >
    <template v-slot:default="{ hover }">
      <v-card @click="$emit('click')" :class="bookCoverClass" elevation="6" hover>
        <v-img :aspect-ratio="aspectRatio" :src="cover.url"/>
        <v-fade-transition>
          <v-overlay absolute color="accent" opacity="0.75" v-if="hover">
            <v-btn icon>
              <v-icon>get_app</v-icon>
            </v-btn>
          </v-overlay>
        </v-fade-transition>
      </v-card>
    </template>
  </v-hover>
</template>

<script>
export default {
  props: {
    cover: {
      required: true,
    },
  },
  computed: {
    bookCoverClass() {
      return !this.breakpoint ? 'book-cover' : 'mb-6';
    },
    breakpoint() {
      return !this.$vuetify.breakpoint.mdAndUp;
    },
    aspectRatio() {
      return (this.cover.width / this.cover.height);
    },
  },
};
</script>

<style>
  .book-cover {
    z-index: 5;
  }
</style>
